import Footer from '../Footer'

// Per the design.md spec, the global Footer is used here. The page-local
// footer was intentionally removed from the design, and the existing
// global Footer component is rendered in its place.
export default Footer
